import { Spin } from 'antd';
import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { moduleListApi } from '@services/MedProject';

import Modules from '../components/MedProject/Projects/Modules';
import Members from '../components/MedProject/Projects/Members';
import Notices from '../components/MedProject/Projects/Notices';
import QuickEntries from '../components/MedProject/Projects/QuickEntries';
import Setting from '../components/MedProject/Projects/Setting';
import MedProject from '../components/MedProject/MedProjects/MedProject';

import { WORKSPACE_ROUTE_BASE } from '../layouts/workspaceConfig';
import { workspaceMedProjectModulesPath } from '../layouts/medProjectWorkspacePaths';

function WorkspaceMedProjectUnknownRedirect() {
    const { projectId } = useParams();
    return <Navigate to={`${WORKSPACE_ROUTE_BASE}/${projectId}`} replace />;
}

function WorkspaceMedProjectIndexRedirect() {
    const { projectId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (projectId == null || projectId === '') {
            navigate('/medproject/projects', { replace: true });
            return;
        }

        let cancelled = false;

        moduleListApi({ projectId })
            .then(res => {
                if (cancelled) return;

                const aid = res?.data?.find(item => item.moduleType === 'activity')?.id;
                const fid = res?.data?.[0]?.id;
                const mid = aid ?? fid ?? 0;
                navigate(workspaceMedProjectModulesPath(projectId, mid), { replace: true });
            })
            .catch(() => {
                if (!cancelled) {
                    navigate(workspaceMedProjectModulesPath(projectId, 0), { replace: true });
                }
            });

        return () => {
            cancelled = true;
        };
    }, [projectId, navigate]);

    return (
        <div style={{ padding: 48, textAlign: 'center' }}>
            <Spin />
        </div>
    );
}

/**
 * 「新增项目」与「项目信息」共用 WorkspaceLayout：
 * - `:projectId === 'new'`：index 路由直接渲染新增表单
 * - 其他真实 ID：按模块默认跳转到活动模块（原有行为）
 */
function WorkspaceMedProjectIndexRoute() {
    const { projectId } = useParams();
    if (projectId === 'new') return <MedProject />;
    return <WorkspaceMedProjectIndexRedirect />;
}

export default [
    { index: true, element: <WorkspaceMedProjectIndexRoute /> },
    { path: 'info', element: <MedProject /> },
    { path: 'modules/:id', element: <Modules /> },
    { path: 'members', element: <Members /> },
    { path: 'notices', element: <Notices /> },
    { path: 'quick-entries', element: <QuickEntries /> },
    { path: 'setting', element: <Setting /> },
    { path: '*', element: <WorkspaceMedProjectUnknownRedirect /> },
];
